"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Avatar = exports.AVATAR_SIZES = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols"));
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _assign = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/assign"));
var _trim = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/trim"));
var _bind = _interopRequireDefault(require("classnames/bind"));
var _reactToString = _interopRequireDefault(require("react-to-string"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon/Icon");
var _Avatar = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Avatar.css") : void 0);
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof _getOwnPropertySymbols.default === "function") for (var i = 0, p = (0, _getOwnPropertySymbols.default)(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var CSS_BLOCK = 'sapcnqr-avatar';
var AVATAR_SIZES = exports.AVATAR_SIZES = ['xl', 'lg', 'md', 'sm', 'xs'];
/** An **Avatar** is a visual representation of an user in the digital space.
 * Usually, an avatar displays the user in one of the following ways:
 * photo of the user, initials of the user, placeholder icon instead of the user’s
 * personal data (photo or initials). */
var Avatar = exports.Avatar = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var _context, _context2;
  var ariaLabel = props.ariaLabel,
    _props$accentColor = props.accentColor,
    accentColor = _props$accentColor === void 0 ? 6 : _props$accentColor,
    badgeIconName = props.badgeIconName,
    border = props.border,
    className = props.className,
    iconName = props.iconName,
    imageUrl = props.imageUrl,
    children = props.children,
    onClick = props.onClick,
    _props$size = props.size,
    size = _props$size === void 0 ? 'sm' : _props$size,
    square = props.square,
    transparent = props.transparent,
    placeholder = props.placeholder,
    otherProps = __rest(props, ["ariaLabel", "accentColor", "badgeIconName", "border", "className", "iconName", "imageUrl", "children", "onClick", "size", "square", "transparent", "placeholder"]);
  var classnames = _bind.default.bind(_Avatar.default);
  var avatarClasses = classnames(CSS_BLOCK, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, (0, _concat.default)(_context = "".concat(CSS_BLOCK, "--")).call(_context, size), !!size), (0, _concat.default)(_context2 = "".concat(CSS_BLOCK, "--accent")).call(_context2, accentColor), accentColor && !placeholder && !transparent), "".concat(CSS_BLOCK, "--placeholder"), placeholder), "".concat(CSS_BLOCK, "--square"), square), "".concat(CSS_BLOCK, "--transparent"), transparent), "".concat(CSS_BLOCK, "--border"), border), "".concat(CSS_BLOCK, "--clickable"), onClick), className);
  var iconSizeMap = {
    xl: 'xl',
    lg: 'lg-plus',
    md: 'lg-minus',
    sm: 'md-minus',
    xs: 'sm'
  };
  var innerContent;
  // render a gender neutral icon if provided initial are longer than 3 characters
  if (children) {
    if ((0, _reactToString.default)(children).length > 3) {
      innerContent = /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
        ariaHidden: true,
        iconName: "user",
        size: iconSizeMap[size]
      });
    } else {
      innerContent = children;
    }
  } else if (iconName) {
    innerContent = /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
      ariaHidden: true,
      iconName: iconName,
      size: iconSizeMap[size]
    });
  }
  var badgeIconSizeMap = {
    xl: 'sm',
    lg: 'xs-plus',
    md: 'xs',
    sm: 'xs',
    xs: 'xs'
  };
  var content = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, innerContent, onClick && badgeIconName && ( /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    ariaHidden: true,
    className: classnames("".concat(CSS_BLOCK, "__badge")),
    iconName: badgeIconName,
    size: badgeIconSizeMap[size]
  })));
  if (typeof onClick === 'function') {
    return /*#__PURE__*/_react.default.createElement("button", (0, _assign.default)({
      type: "button"
    }, otherProps, {
      tabIndex: 0,
      onClick: onClick,
      "aria-label": ariaLabel,
      className: avatarClasses,
      style: (imageUrl === null || imageUrl === void 0 ? void 0 : (0, _trim.default)(imageUrl).call(imageUrl)) ? {
        backgroundImage: "url(".concat(imageUrl, ")")
      } : undefined,
      ref: ref
    }), content);
  }
  return /*#__PURE__*/_react.default.createElement("span", (0, _assign.default)({}, otherProps, {
    "aria-label": ariaLabel,
    className: avatarClasses,
    role: "img",
    style: (imageUrl === null || imageUrl === void 0 ? void 0 : (0, _trim.default)(imageUrl).call(imageUrl)) ? {
      backgroundImage: "url(".concat(imageUrl, ")")
    } : undefined,
    ref: ref
  }), content);
});
Avatar.displayName = 'Avatar';
var _default = exports.default = Avatar;